import { render, staticRenderFns } from "./AxSearchbar.vue?vue&type=template&id=1813268a&"
import script from "./AxSearchbar.vue?vue&type=script&lang=ts&"
export * from "./AxSearchbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1813268a')) {
      api.createRecord('1813268a', component.options)
    } else {
      api.reload('1813268a', component.options)
    }
    module.hot.accept("./AxSearchbar.vue?vue&type=template&id=1813268a&", function () {
      api.rerender('1813268a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/AxSearchbar/AxSearchbar.vue"
export default component.exports